var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentAbiertaD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 193,
    viewBox: "0 0 160 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.26 51.46L80.06 7.76L67.62 0.529999V14.92V134.38V139.14L71.74 141.54L146.94 185.24L159.38 192.47V178.08V58.62V53.86L155.26 51.46Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 58.62L75.9 14.92V134.38L151.1 178.08V58.62Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 166.07L85.87 128.16V20.71L75.9 14.92V122.37V134.38L85.87 140.17L151.1 178.08V166.07Z",
    fill: "#DDDDDF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.87 128.16V20.71L75.9 14.92V122.37V134.38L85.87 128.16Z",
    fill: "#A6A6A7",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4571 104.909V110.199C13.4644 110.582 13.369 110.961 13.1809 111.295C12.9927 111.629 12.7187 111.907 12.3871 112.099L10.9371 112.939C10.7593 113.042 10.5578 113.096 10.3525 113.097C10.1472 113.098 9.94523 113.046 9.76648 112.945C9.58773 112.844 9.43842 112.698 9.33331 112.522C9.22819 112.345 9.17091 112.144 9.16712 111.939V107.099C9.17766 106.692 9.29263 106.294 9.501 105.944C9.70936 105.594 10.0041 105.303 10.3571 105.099L12.0271 104.099C12.1726 104.029 12.333 103.995 12.4944 104.001C12.6558 104.006 12.8136 104.05 12.9541 104.13C13.0947 104.209 13.2138 104.322 13.3014 104.458C13.389 104.593 13.4424 104.748 13.4571 104.909Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6671 104.899C14.8871 110.509 14.5971 118.569 13.6671 124.219C13.5869 124.626 13.412 125.008 13.1566 125.335C12.9013 125.661 12.5725 125.923 12.1971 126.099C11.6571 126.379 11.1171 126.659 10.5671 126.929C9.67709 127.379 8.83709 126.829 9.02709 125.929C10.1771 120.489 10.7071 112.599 9.80709 107.129C9.73462 106.755 9.77048 106.368 9.91043 106.014C10.0504 105.66 10.2886 105.353 10.5971 105.129L12.0571 104.129C12.2116 104.056 12.3805 104.018 12.5514 104.019C12.7223 104.019 12.8911 104.057 13.0453 104.131C13.1995 104.205 13.3353 104.312 13.4429 104.445C13.5505 104.578 13.627 104.733 13.6671 104.899Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 58.7L76.2 15V134.46L1 178.16V58.7Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentAbiertaD);
export default __webpack_public_path__ + "static/media/VentAbiertaD.d3fe391254eb39ea4d3e512903f20cb8.svg";
export { ForwardRef as ReactComponent };